import request from '@/utils/request'


// 查询商品库存后台审核变动记录列表
export function listSkuAdmStockLog(query) {
  return request({
    url: '/goods/sku/adm/stock/log/list',
    method: 'get',
    params: query
  })
}

// 查询商品库存后台审核变动记录分页
export function pageSkuAdmStockLog(query) {
  return request({
    url: '/goods/sku/adm/stock/log/page',
    method: 'get',
    params: query
  })
}

// 查询商品库存后台审核变动记录详细
export function getSkuAdmStockLog(data) {
  return request({
    url: '/goods/sku/adm/stock/log/detail',
    method: 'get',
    params: data
  })
}

// 新增商品库存后台审核变动记录
export function addSkuAdmStockLog(data) {
  return request({
    url: '/goods/sku/adm/stock/log/add',
    method: 'post',
    data: data
  })
}

// 修改商品库存后台审核变动记录
export function updateSkuAdmStockLog(data) {
  return request({
    url: '/goods/sku/adm/stock/log/edit',
    method: 'post',
    data: data
  })
}

// 删除商品库存后台审核变动记录
export function delSkuAdmStockLog(data) {
  return request({
    url: '/goods/sku/adm/stock/log/delete',
    method: 'post',
    data: data
  })
}
